var $ = require( "jquery" )

$(document).ready( function(){
  $('button:submit:not([data-skip-disable])').click(function(){
    if (!window.location.pathname.startsWith('/admin')) {
      var form = $(this).closest('form')[0];

      // form.submit() below is the native DOM method, which skips the HTML5 validation.
      // For a form that asks for it with data-check-validity,
      // bail out here when it is invalid so the button's own default action runs
      // instead -- that one does validate, and shows the browser's message
      // against the offending field. This handler is on every
      // form in the app, and the rest have never had their constraints enforced.
      if (form && form.hasAttribute('data-check-validity') &&
          typeof form.checkValidity === 'function' && !form.checkValidity()) {
        return;
      }

      $("span.action", this).html('Submitting, please wait...');
      $(this).prop("disabled", true);
      var button = this;
      $(this).closest('form').submit();
      window.setTimeout(function() {
        $(button).prop("disabled", false);
      }, 500);
    }
  });

  $('form[method=get]').children('button:submit, input:submit').click(function(){
    $(this).closest('form').submit();
    var button = this;
    window.setTimeout(function() {
      console.log("timeout");
      $(button).closest('form').children('button:submit, input:submit').each(function(){
        $(this).prop("disabled", false);
      })
    }, 500);
  });

  // Ignore returns on forms when tagged with data-ignore-return
  if($('form[data-ignore-return]').length > 0) {
    $(window).keydown(function(event){
      if(event.keyCode == 13) {
        event.preventDefault();
        return false;
      }
    });
  }
});
